<template lang="pug">
  div.infoArea(v-if="display === true",:style="style()",@click="onclick")
    figure
      img(:src="'./static/thumb/' + dat.code + '.jpg'")
    div.spec
      div.name {{ dat.name }}
      div.code {{ dat.code }}
      div.price  {{ addComma(dat.price) }}円
      div.size
        dl.width(v-if="check(dat.w)")
          dt 横幅&nbsp;
          dd {{ dat.w * 10 }}mm
        dl.height(v-if="check(dat.h)")
          dt 高さ&nbsp;
          dd {{ dat.h * 10 }}mm
        dl.depth(v-if="check(dat.d)")
          dt 奥行&nbsp;
          dd  {{ dat.d * 10 }}mm
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'ItemInfo',
  components: {
  },
  data () {
    return {
      dat: {},
      left: 0,
      top: 0,
      display: false
    };
  },
  props: {
    // pnum: Number,
    // num: Number,
    // dat: Object
  },
  computed: {
    infoitem () {
      return this.$store.getters.infoitem;
    }
  },
  watch: {
    infoitem (s) {
      this.dat = s.item;
      this.display = s.display;
      this.left = s.left;
      this.top = s.top;
    }
  },
  methods: {
    check (n) {
      if (n !== '' && n !== undefined && n !== 0 && n !== '-') {
        return true;
      } else {
        return false;
      }
    },
    style () {
      return {
        left: this.left + 'px',
        top: this.top + 'px'
      };
    },
    onclick () {
      let dat = {
        display: false
      };
      store.commit('setInfoitem', dat);
    }
  },
  created () {
  },
  destroyed () {
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .infoArea
    min-width 230px
    color #ffffff
    background-color #00000088
    padding 8px
    border-radius 5px
    position fixed
    z-index 1000
    left 160px
    top 100px
    display flex
    transform translate(-50%, 30px)
    figure
      width 120px
      overflow hidden
      img
        width 100%
    .spec
      padding 0 0 0 10px
      flex 1
      .name
        font-weight bold
        font-size 14px
      div,dl
        font-weight bold
        font-size 13px
      .price
        text-align right
      .size
        display flex
        dl
          display flex
          justify-content space-between
        dl + dl
          margin-left 10px
</style>



// WEBPACK FOOTER //
// src/components/parts/ItemInfo.vue